export default __webpack_public_path__ + "./image/c0f051b956292ce9454f02a80458d702.svg";